<template>
  <div>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/scheduled_messages/store">{{ $t("communication.globalMessages.newScheduledMessage") }}</v-btn>
    <DataTable ref="reserDataTable" :url="api.ACTIONS.GLOBAL_MESSAGE" :titles="titles"
      :fields-hidden-main="['id', 'updated_at', 'deleted_at']" :title="$t('communication.globalMessages.title')" :enableEdit="false"
      :enableAdd="false" :enableDelete="false" :actions-extra-main="actionsExtraMain" :formatter="formatters" />
  </div>
</template>

<style>
.hbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";

export default {
  name: "Scheduled Messages",
  title() {
    return this.$t("communication.globalMessages.title");
  },
  components: { DataTable },
  data() {
    return {
      formatters: {
        created_at(value) {
          return moment(value).format("DD-MM-YYYY HH:mm");
        },
        end_time(value) {
          return moment(value).format("DD-MM-YYYY HH:mm");
        },
      },
    };
  },

  computed: {
    rules() {
      return {
        name: [required],
      };
    },
    titles() {
      return {
        id: this.$t("communication.globalMessages.id"),
        created_at: this.$t("communication.globalMessages.start"),
        end_time: this.$t("communication.globalMessages.end"),
        step: this.$t("communication.globalMessages.interval"),
        message: this.$t("communication.globalMessages.message"),
      };
    },
    actionsExtraMain() {
      return {
        deleteMessage: {
          title: this.$t("communication.globalMessages.deleteScheduledMessage"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.loading = true;
            this.axios
              .delete(`global_message/${id}`)
              .then((res) => {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("communication.globalMessages.deletedSuccessfully"),
                  "green"
                );
                this.$refs.reserDataTable.getData();
              })
              .catch((err) => {
                let response = err.response;
                if (response) {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    response.data.message,
                    "red"
                  );
                } else {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("communication.globalMessages.somethingWentWrong"),
                    "red"
                  );
                }
              })
              .finally(() => (this.loading = false));
          },
        },
      };
    },
  },
};
</script>
